import React from "react";
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious
} from "../../shadcnComponents/ui"
import Select from "react-select";
import { paginationMenuStyling, paginationMenuTheme } from "../../file-browser/reactSelectStyling";

export function PaginationElement(props) {

    return (
        <div className="w-full flex gap-4 text-sm my-5">
            <span className="flex flex-col justify-center ml-auto">Καταχωρήσεις ανά σελίδα</span>
            <Select className="rounded-lg h-5 my-auto"
                isDisabled={false}
                isMulti={false}
                isSearchable={false}
                onChange={(e) => { props.setItemsPerPage(e.value) }}
                options={[{ label: 5, value: 5 }, { label: 10, value: 10 }, { label: 25, value: 25 }, { label: 50, value: 50 }, { label: 100, value: 100 }]}
                defaultValue={{ label: props.itemsPerPage, value: props.itemsPerPage }}
                theme={paginationMenuTheme}
                styles={paginationMenuStyling}
            />
            <Pagination className="w-fit mt-auto ml-2">
                <PaginationContent>
                    <PaginationItem onClick={() => { props.page > 1 ? props.setPage(props.page - 1) : '' }}>
                        <PaginationPrevious href="#" />
                    </PaginationItem>
                    {props.pageItemsArray.map(each => {
                        return (
                            <PaginationItem key={'page' + props.pageItemsArray.indexOf(each)} onClick={() => { props.setPage(props.pageItemsArray.indexOf(each) + 1) }}>
                                <PaginationLink href="#" isActive={props.pageItemsArray.indexOf(each) + 1 == props.page}>{props.pageItemsArray.indexOf(each) + 1}</PaginationLink>
                            </PaginationItem>
                        )
                    })}
                    {props.pageItemsArray.length > 4 &&
                        <PaginationItem>
                            <PaginationEllipsis />
                        </PaginationItem>
                    }
                    <PaginationItem onClick={() => { props.page < props.pageItemsArray.length ? props.setPage(props.page + 1) : '' }}>
                        <PaginationNext href="#" />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
        </div>
    )
}
export default PaginationElement